import React, { useRef, useState } from "react";
import { toast } from "react-toastify";
import { apiCaller } from "../../../../services/AxiosInstance";
import { getImageUrl } from "../../../pages/Artist/ArtistAvatar";
import { Link } from "react-router-dom";

const CustomImageUpload = ({
  fieldName,
  error,
  value,
  label,
  handleBlur,
  classes,
  inputType = "text",
  handleChange,
  inputProps,
  setFieldValue,
  mediaType = '',
  imageRatio
}) => {
  const fileInputRef = useRef(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [fileName, setFileName] = useState("");
  const [filePath, setFilePath] = useState(value ?? "");
  const [fileError, setFileError] = useState("");

  const handleSelectClick = () => {
    fileInputRef.current.click();
  };

  const validateFile = (file) => {
    const FILE_SIZE = 5 * 1024 * 1024;
    let SUPPORTED_FORMATS = [];
    switch (mediaType) {
      case 'pdf':
        SUPPORTED_FORMATS = ["application/pdf"];
        break;
      case 'svg':
        SUPPORTED_FORMATS = ["image/svg+xml", "image/svg", "application/svg+xml"];
        break;

      default:
        SUPPORTED_FORMATS = ["image/jpg", "image/jpeg", "image/png"]
        break;
    }
    if (!SUPPORTED_FORMATS.includes(file.type)) {
      return "Only JPG, JPEG, PNG are allowed";
    }

    if (file.size > FILE_SIZE) {
      return "File size should be less than 5MB";
    }

    return null;
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const fileErrorMsg = validateFile(file);
      if (fileErrorMsg) {
        setFileError(fileErrorMsg);
        return;
      }
      setSelectedFile(file);
      setFileName(file.name);
      setFieldValue(fieldName, file);
      setFileError("");
    } else {
      setFieldValue(fieldName, null);
      setSelectedFile(null);
      setFileName("");
    }
  };

  const handleUploadClick = async () => {
    if (!selectedFile) return setFileError("Please select a file first.");

    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const res = await apiCaller({
        method: "post",
        url: "upload",
        params: null,
        data: formData,
      });
      if (res?.data?.data?.url) {
        setFilePath(res?.data?.data?.url);
        setFieldValue(fieldName, res?.data?.data?.url);
      } else {
        setFilePath("");
        setFieldValue(fieldName, "");
      }
    } catch (err) {
      setFilePath("");
      setFieldValue(fieldName, "");
      console.error(err);
    }
  };

  const handleRemoveClick = async () => {
    if (!fileName && !filePath) return toast.error("Please upload a file first.");
    if (filePath) {
      setFileName("");
      setFilePath("");
      setFieldValue(fieldName, "");
    } else {
      setFileName("");
      setFilePath("");
      setFieldValue(fieldName, "");
    }
  };

  return (
    <div
      className={`form-group ${classes ? classes : ""} mb-3 ${error ? "is-invalid" : "is-valid"
        }`}
    >
      <label className="text-label">{label}</label>
      <input
        type="file"
        accept={mediaType === "pdf"
          ? ".pdf"
          : mediaType === "svg"
            ? "image/svg+xml"
            : "image/*"}
        ref={fileInputRef}
        onChange={handleFileChange}
        style={{ display: "none" }}
      />
      <div
        className={`d-flex align-items-center flex-wrap m-0 ${filePath || fileName ? "gap-3" : ""}`}
      >
        <div
          className={!filePath ? "w-100" : ""}
          style={
            filePath ? { width: "fit-content", maxWidth: "100%" } : undefined
          }
        >
          {filePath ? (
            mediaType == 'pdf' ? (
              <Link target="_blank" to={getImageUrl(filePath)} className={"fs-3"}>Concept PDF</Link>
            ) : (
              <img
                src={getImageUrl(filePath)}
                alt="Uploaded"
                style={
                  imageRatio == "1_1"
                    ? {
                        width: mediaType == "svg" ? "70px" : "100px",
                        height: mediaType == "svg" ? "70px" : "100px",
                        objectFit: "contain",
                      }
                    : imageRatio == "9_16"
                      ? {
                          width: "200px",
                          maxHeight: "400px",
                          objectFit: "contain",
                        }
                      : {
                          maxWidth: "100%",
                          maxHeight: 320,
                          width: "auto",
                          height: "auto",
                          objectFit: "contain",
                          display: "block",
                        }
                }
              />
            )
          ) : (
            <div className="input-group">
              <input
                className="form-control"
                type="text"
                value={fileName}
                readOnly
              />
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleSelectClick}
                style={{
                  background: "#F9FBFF",
                  color: "var(--abhi-color7)",
                  borderColor: "var(--abhi-color7)",
                }}
              >
                Select
              </button>
            </div>
          )}
        </div>
        {filePath || fileName ? (
          <button
            className="btn btn-primary flex-shrink-0"
            type="button"
            onClick={handleRemoveClick}
          >
            Remove
          </button>
        ) : null}
      </div>

      {error && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {error}
        </div>
      )}

      {fileError && (
        <div
          id={`val-${fieldName}-error`}
          class="invalid-feedback animated fadeInUp"
          style={{ display: "block" }}
        >
          {fileError}
        </div>
      )}
    </div>
  );
};

export default CustomImageUpload;
